"use client";
import Meter from "@/components/common/meter";
import { ourAchievement } from "@/data/data";
import * as motion from "motion/react-client";

interface Props {
    style?: "style-2";
}

const OurAchievement = ({ style }: Props) => {
    return (
        <section
            className={`desilo-funfacts-section overflow-hidden ${
                style === "style-2"
                    ? "section-padding-top"
                    : "section-padding-top-bottom"
            }`}
            id="our-achievement-01"
        >
            <div className="container custom-container">
                <div className="row">
                    <div className="col-12">
                        <div className="desilo-funfacts__wrapper">
                            {/* funfact start */}
                            {ourAchievement?.map((item, i) => {
                                return (
                                    <motion.div
                                        key={i}
                                        initial={{ opacity: 0, x: 100 }}
                                        whileInView={{
                                            opacity: 1,
                                            x: 0,
                                            transition: {
                                                duration: 0.5,
                                            },
                                        }}
                                        viewport={{
                                            once: true,
                                        }}
                                        className="desilo-funfact-box"
                                    >
                                        {(() => {
                                            const unitStr = (item.unit || '');
                                            const unitText = unitStr.replace(/\s+/g, '');
                                            const showLeadingZero = (!unitText || unitText.length === 0) && typeof item.value === 'number' && item.value < 10;
                                            return (
                                                <h2 className="counter-item d-inline-flex align-items-baseline gap-1">
                                                    {showLeadingZero && <span>0</span>}
                                                    <Meter value={item.value} />
                                                    {unitText && (
                                                        <span style={{ marginLeft: 6, fontStyle: 'normal', lineHeight: 1 }}>
                                                            {unitText}
                                                        </span>
                                                    )}
                                                </h2>
                                            );
                                        })()}
                                        <span className="funfact-info">
                                            {item.label}
                                        </span>
                                    </motion.div>
                                );
                            })}
                            {/* funfact end */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurAchievement;
